<template>
  <div>
    <input
      id="file-upload"
      class="d-none"
      type="file"
      multiple
      :disabled="disabled"
      @change="handleUploadAnexos"
    />

    <v-tooltip
      top
      color="primary"
    >
      <template v-slot:activator="{ on, attrs }">
        <label
          class="d-flex align-center ml-2 mr-4"
          for="file-upload"
        >
          <v-icon
            v-bind="attrs"
            class="cursor-pointer"
            :disabled="disabled"
            v-on="on"
          >
            {{ icons.mdiAttachment }}
          </v-icon>
        </label>
      </template>

      <span>Anexar arquivo</span>
    </v-tooltip>
  </div>
</template>

<script>
import { computed } from '@vue/composition-api'
import { mdiAttachment } from '@mdi/js'

export default {
  props: {
    handleUploadAnexos: {
      type: Function,
      required: true,
    },
    editavel: {
      type: Boolean,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
    clicouNoIconeDeAudio: {
      type: Boolean,
      required: true,
    },
    ticketEstaFinalizado: {
      type: Boolean,
      required: true,
    },
    notificarObrigatoriedadeDoEnvioDoTemplateDe24Horas: {
      type: Boolean,
      required: true,
    },
  },

  setup(props) {
    const disabled = computed(() => (
      !props.editavel
        || props.loading
        || props.clicouNoIconeDeAudio
        || props.ticketEstaFinalizado
        || props.notificarObrigatoriedadeDoEnvioDoTemplateDe24Horas
    ))

    return {
      disabled,
      icons: {
        mdiAttachment,
      },
    }
  },
}
</script>
